import { MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

const ServiceAreasSection = () => {
  const areas = [
    { name: 'Calgary', primary: true },
    { name: 'Mahogany', primary: false },
    { name: 'Auburn Bay', primary: false },
    { name: 'Seton', primary: false },
    { name: 'Legacy', primary: false },
    { name: 'Okotoks', primary: false },
    { name: 'Airdrie', primary: false },
    { name: 'Cochrane', primary: false },
    { name: 'Chestermere', primary: false },
  ];

  return (
    <section className="py-16 md:py-20 bg-[#f8f9fa]" data-testid="service-areas-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <p className="text-[#c5a059] text-sm uppercase tracking-[0.3em] mb-4">
              Local Service
            </p>
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-[#0f172a] mb-6">
              Serving Calgary & Surrounding Areas
            </h2>
            <p className="text-slate-600 text-lg mb-8 leading-relaxed">
              We proudly serve Calgary and nearby communities with high-quality renovation services. 
              As a local contractor, we understand the unique needs of Alberta homes and deliver 
              craftsmanship that exceeds expectations.
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 text-[#0f172a] font-semibold hover:text-[#c5a059] transition-colors"
              data-testid="service-areas-cta"
            >
              <MapPin className="w-5 h-5" />
              Check if we serve your area
            </Link>
          </div>

          {/* Areas Grid */}
          <div className="bg-white p-8 md:p-10">
            <div className="flex flex-wrap gap-3">
              {areas.map((area, index) => (
                <span
                  key={index}
                  className={`px-4 py-2 text-sm font-medium transition-colors ${
                    area.primary
                      ? 'bg-[#0f172a] text-white'
                      : 'bg-[#f8f9fa] text-[#0f172a] hover:bg-[#0f172a] hover:text-white'
                  }`}
                  data-testid={`service-area-${area.name.toLowerCase().replace(' ', '-')}`}
                >
                  {area.name}
                </span>
              ))}
            </div>
            <p className="text-slate-500 text-sm mt-6">
              Don't see your area? Contact us — we may still be able to help!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreasSection;
